// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Nr-z","slideIn":"Or-z"};